export default __webpack_public_path__ + "static/media/partner-mirrorworld.65ce1d81.png";